import { apiClient } from '@/lib/api'
import type { KpiReport } from '@/types/analytics'

// KPI report for the 12 months ending with `month` (YYYY-MM). Omitted, the
// backend defaults to the current month.
export function fetchKpis(month?: string): Promise<KpiReport> {
  return apiClient<KpiReport>('/analytics/kpis', {
    params: month ? { month } : undefined,
  })
}
